import { loadModal } from '../../AsyncLoader';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';


function getModalProperties() {
  const key = ComponentKeys.UTILITY_NAVIGATION;

  return {
    title: ContentStorage.getValue(key, 'ExpiredModalTitle'),
    text: ContentStorage.getValue(key, 'ExpiredModalText'),
    button: ContentStorage.getValue(key, 'ExpiredModalButton'),
  };
}


async function open() {
  const Modal = await loadModal();

  const { formButtonHandler } = window.tnew.handlers;
  const { title, text, button } = getModalProperties();

  const $btn = Modal.utils.makePrimaryButton(button);

  $btn.on('click', () => {
    formButtonHandler.applyBusyStyling($btn);

    setTimeout(() => {
      window.location.reload();
    }, 100);
  });

  Modal.open({
    className: 'tn-cart-expired-modal',
    title,
    bodyContents: text,
    footerContents: $btn,
    closeOnEscape: false,
    closeOnBackdrop: false,
    closeButtonInHeader: false,
  });
}


export default {
  open,
};



// WEBPACK FOOTER //
// ./V7/cart/timer/CartExpiredModal.js